<template>
    <div class="login-wrap">
        <div class="ms-login">
            <div class="ms-title">后台管理系统</div>
            <el-form :model="param" :rules="rules" ref="param" label-width="0px" class="ms-content">
                <el-form-item prop="company_account">
                    <el-input v-model="param.company_account" placeholder="username">
                        <el-button slot="prepend" icon="el-icon-lx-people"></el-button>
                    </el-input>
                </el-form-item>
                <el-form-item prop="company_password">
                    <el-input type="password" placeholder="password" v-model="param.company_password"
                        @keyup.enter.native="submitForm()">
                        <el-button slot="prepend" icon="el-icon-lx-lock"></el-button>
                    </el-input>
                </el-form-item>
                <div class="login-btn">
                    <el-button type="primary" @click="submitForm()">登录</el-button>
                </div>
              
            </el-form>
        </div>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                param: {
                    company_account: '',
                    company_password: '',
                },
                rules: {
                    company_account: [{
                        required: true,
                        message: '请输入用户名',
                        trigger: 'blur'
                    }],
                    company_password: [{
                        required: true,
                        message: '请输入密码',
                        trigger: 'blur'
                    }],
                },
                item1: [{
                        icon: 'el-icon-lx-home',
                        index: 'dashboard',
                        title: '数据统计'
                    },
                    {
                        icon: 'el-icon-lx-home',
                        index: 'add-Merchant',
                        title: '编辑商户信息'
                    },
                    {
                        icon: 'el-icon-lx-copy',
                        index: 'order',
                        title: '交易明细'
                    },
                    {
                        icon:'el-icon-bell',
                        index: 'voice',
                        title:'语音播报'
                    }
                ]
            };
        },
        methods: {
            submitForm() {
                let that = this
                this.$refs.param.validate(valid => {
                    if (valid) {
                        let url = this.$apiUrl.login.login
                        that.$post(url, that.$params(that.param)).then(res => {
                            if (res.data.code == 200) {
                                sessionStorage.clear()
                                  sessionStorage.setItem('user_login_auth',res.data.data.auth)
                                if(res.data.data.auth){
                                    this.$message.success('登录成功');
                                    sessionStorage.setItem('ms_username', this.param.company_account);
                                    if(res.data.data.auth=="2")
                                    {
                                        sessionStorage.setItem('mid',res.data.data.company_mid)
                                        sessionStorage.setItem('merchants_id',res.data.data.id)
                                        that.$store.commit('setItem', this.item1)
                                        console.log(this.$store.state.item)
                                    }
                                     this.$router.push('/')
                                  
                                }
                                else{
                                    this.$message.error(res.data.msg)
                                }
                            }
                        }).catch(error => {
                           
                            this.$message.error(error)
                        })

                    } else {
                        this.$message.error('请输入账号和密码');
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
    };
</script>

<style scoped>
    .login-wrap {
        position: relative;
        width: 100%;
        height: 100%;
        background-image: url(../assets/img/login-bg.jpg);
        background-size: 100%;
    }

    .ms-title {
        width: 100%;
        line-height: 50px;
        text-align: center;
        font-size: 20px;
        color: #fff;
        border-bottom: 1px solid #ddd;
    }

    .ms-login {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 350px;
        margin: -190px 0 0 -175px;
        border-radius: 5px;
        background: rgba(255, 255, 255, 0.3);
        overflow: hidden;
    }

    .ms-content {
        padding: 30px 30px;
    }

    .login-btn {
        text-align: center;
    }

    .login-btn button {
        width: 100%;
        height: 36px;
        margin-bottom: 10px;
    }

    .login-tips {
        font-size: 12px;
        line-height: 30px;
        color: #fff;

    }
</style>